import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import '@/permission'
import '@/styles/common.css'

import { ElCollapseTransition } from 'element-plus'
import 'element-plus/dist/index.css';




const app = createApp(App)
app.use(ElementPlus, {
    locale: zhCn,
})

app.use(router)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.component(ElCollapseTransition.name)
app.mount('#app')




// 解决异常bug
const debounce = (fn, delay) => {
    let timer = null;
    return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
    constructor(callback) {
        callback = debounce(callback, 16);
        super(callback);
    }
}



// 子页面中
window.addEventListener("message", (event) => {
    // 安全验证
    if (event.data.type === "OPEN_MODAL") {
        // 向父应用发送回复
        // event.source.postMessage(
        //   { type: "CONFIRM", status: "success" },
        //   event.origin // 直接使用来源地址
        // );
    }
});